// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__3aJzD","label":"Section_label__1O9cX","contentWrap":"Section_contentWrap__35oqC","footer":"Section_footer__3lnlM","footerInner":"Section_footerInner__eR0XS"};